import React, { useEffect, useRef, useState } from 'react'
import styles from './Scroll.module.css'
import { IoIosArrowForward, IoIosArrowBack } from "react-icons/io";
import IconComponent from '../../IconComponent/IconComponent';
import axios from 'axios';

export type ScrollProps = {
    categorie: Categories;
    onLoad: () => void;
    loading: boolean;
}

export type Categories = {
    ID: number;
    Name: string;
    Image: string;
}

export type Brands = {
    ID: number
    name: string;
    image: string;
    link: string;
    CategoryID: number;
}

const Scroll = (props: ScrollProps) => {

    const scrollRef = useRef<HTMLDivElement>(null);
    const [canScrollLeft, setCanScrollLeft] = useState(false);
    const [canScrollRight, setCanScrollRight] = useState(false);
    const [brands, setBrands] = useState<Brands[]>([]);

    const updateScrollButtons = () => {
        const el = scrollRef.current;
        if (!el) return;

        setCanScrollLeft(el.scrollLeft > 0);
        setCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth);
    };

    const scrollLeft = () => {
        scrollRef.current?.scrollBy({ left: -500, behavior: 'smooth' });
    };

    const scrollRight = () => {
        scrollRef.current?.scrollBy({ left: 500, behavior: 'smooth' });
    };

    useEffect(() => {
        const el = scrollRef.current;
        if (!el) return;

        el.scrollLeft = (el.scrollWidth - el.clientWidth) / 2;

        updateScrollButtons();

        el.addEventListener('scroll', updateScrollButtons);
        window.addEventListener('resize', updateScrollButtons);

        return () => {
            el.removeEventListener('scroll', updateScrollButtons);
            window.removeEventListener('resize', updateScrollButtons);
        };
    }, [brands]);

    useEffect(() => {
        const fetchAll = async () => {
            try {
                const [brands] = await Promise.all([
                    axios.get("https://sazuli.pt/api/brands", { params: { categoryId: props.categorie.ID } })
                ]);
                setBrands(brands.data);
            } catch (err) {
                console.error("Data fetch error:", err);
            } finally {
                props.onLoad(); // ✅ Notify parent when this scroll is loaded
            }
        };
        fetchAll();
    }, [props.categorie]);

    return (
        <div className={styles.item}>
            <h3>{props.categorie.Name}</h3>

            <div className={styles.scrollWrapper}>
                <div className={styles.scrollArrows}>
                    <div
                        className={`${styles.scrollLeft} ${!canScrollLeft ? styles.disabled : styles.scrollArrow}`}
                        onClick={canScrollLeft ? scrollLeft : undefined}
                    >
                        <IconComponent size={30} icon={IoIosArrowBack} />
                    </div>
                    <div
                        className={`${styles.scrollRight} ${!canScrollRight ? styles.disabled : styles.scrollArrow}`}
                        onClick={canScrollRight ? scrollRight : undefined}
                    >
                        <IconComponent size={30} icon={IoIosArrowForward} />
                    </div>
                </div>
                <div className={styles.list} ref={scrollRef}>
                    {props.loading
                        ? Array.from({ length: 20 }).map((_, index) => (
                            <div className={`${styles.brand} ${styles.skeleton}`} key={index} />
                        ))
                        : brands.map((item, index) => (
                            <div className={styles.brand} key={index}
                                onClick={() => {
                                    if (item.link) {
                                        window.open(item.link, '_blank');
                                    }
                                }}>
                                <img
                                    src={
                                        item.image
                                            ? `https://sazuli.pt/uploads/${item.image}`
                                            : './assets/images/placeholder_image.png'
                                    }
                                    alt={item.name}
                                />
                                  <div className={styles.overlay}></div>
                            </div>
                        ))}
                </div>
            </div>
        </div>
    )
}

export default Scroll
